var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Icon } from '../../Icon';
import { SelectContext } from '../Select.context';
import { OptionContainer, OptionContent, SideElementContainer, } from './Option.style';
var InnerOption = function (_a) {
    var label = _a.label, selected = _a.selected, focused = _a.focused, disabled = _a.disabled, props = __rest(_a, ["label", "selected", "focused", "disabled"]);
    var ref = React.useRef(null);
    var multi = React.useContext(SelectContext).multi;
    React.useEffect(function () {
        if (focused && ref.current) {
            ref.current.focus();
        }
    }, [focused]);
    return (React.createElement(OptionContainer, __assign({ "data-testid": "option-container", "data-selected": selected, "data-disabled": disabled, ref: ref, tabIndex: 0 }, props),
        React.createElement(OptionContent, null, label),
        multi && (React.createElement(SideElementContainer, null, selected && (React.createElement(React.Fragment, null,
            React.createElement(Icon, { icon: "check" }),
            React.createElement(Icon, { icon: "close", "data-hover": true })))))));
};
export var Option = React.memo(InnerOption);
//# sourceMappingURL=Option.js.map